import React from 'react';
import './LoadingIndicatorForDocument.css';

const LoadingIndicatorForDocument = () => {
  return <div className="LoadingIndicatorForDocument"></div>;
};

export default LoadingIndicatorForDocument;
